export default "__VITE_ASSET__C9lcIJ4a__"